"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _uiKit = require("@devsta/ui-kit");

var _FormattedVideoCredits = _interopRequireDefault(require("../../../../../../../../common/FormattedVideoCredits"));

require("./_team-allocation.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function TeamAllocation(_ref) {
  var team = _ref.team,
      onChangeNumber = _ref.onChangeNumber,
      orgBalance = _ref.orgBalance,
      onGoToSetRecurring = _ref.onGoToSetRecurring,
      onDeleteCreditRule = _ref.onDeleteCreditRule;
  var teamId = team.teamId,
      imageUrl = team.imageUrl,
      name = team.name,
      creditRule = team.creditRule,
      currentBalance = team.currentBalance,
      _team$creditBalance = team.creditBalance;
  _team$creditBalance = _team$creditBalance === void 0 ? {} : _team$creditBalance;
  var teamBalance = _team$creditBalance.balance;

  var _ref2 = creditRule || {},
      creditRuleId = _ref2.creditRuleId,
      _ref2$creditQuantity = _ref2.creditQuantity,
      creditQuantity = _ref2$creditQuantity === void 0 ? 0 : _ref2$creditQuantity;

  return /*#__PURE__*/_react.default.createElement("div", {
    key: teamId,
    className: "team-credit-allocation"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "team-credit-allocation__details-container"
  }, /*#__PURE__*/_react.default.createElement(_uiKit.Image, {
    imageUrl: imageUrl,
    defaultIconBackground: "catSkillWhite",
    defaultIconColour: "michael",
    placeholderText: name,
    placeholderTextSize: 22,
    width: "75px",
    height: "75px",
    rounded: true
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "team-credit-allocation__details-container__details"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "team-credit-allocation__details-container__details__name-container"
  }, /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
    highlighted: true,
    noMargin: true
  }, name), !currentBalance ? /*#__PURE__*/_react.default.createElement(_uiKit.ErrorIcon, {
    className: "team-credit-allocation__details-container__details__name-container__error",
    errorMessage: "This team doesn't have any credits",
    id: "".concat(teamId, "-no-credits")
  }) : null), /*#__PURE__*/_react.default.createElement(_FormattedVideoCredits.default, {
    credits: currentBalance
  }), /*#__PURE__*/_react.default.createElement(_FormattedVideoCredits.default, {
    credits: creditQuantity,
    isCreditRule: true
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "team-credit-allocation__input-container"
  }, /*#__PURE__*/_react.default.createElement(_uiKit.NumberChanger, {
    value: teamBalance,
    onChangeNumber: onChangeNumber(team),
    max: teamBalance + orgBalance
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "team-credit-allocation__input-container__recurring-controls"
  }, /*#__PURE__*/_react.default.createElement(_uiKit.Link, {
    onClick: onGoToSetRecurring(team)
  }, "".concat(creditRuleId ? 'Modify Recurring' : 'Set Recurring')), creditRuleId ? /*#__PURE__*/_react.default.createElement(_uiKit.Icon, {
    name: "trash",
    size: 15,
    hoverColor: "redApple",
    onClick: onDeleteCreditRule({
      teamToUpdate: team,
      creditRuleId: creditRuleId,
      creditQuantity: creditQuantity
    })
  }) : null)));
}

var _default = (0, _react.memo)(TeamAllocation);

exports.default = _default;